<template>
  <div class="gate-item">
    <el-tabs v-model="gateId"  @tab-click="setValue">
      <el-tab-pane v-for="(item, i) in gateArr" :key="i"  :label="item.Name" :name="String(item.Id)">
        <span slot="label">
          <el-badge is-dot :hidden="item.hidden" class="item">{{item.Name}}</el-badge>
        </span>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
// import park from '../'
export default {
  data: () => ({
    gateId: '',
    gateArr: [],
  }),
  props: {
    gateArrStr: {
      type: [Array, String],
      default: undefined,
    },
  },
  watch: {
    gateArrStr: {
      handler(val){
        // console.log('gateArrStr', val, this.gateId);
        this.gateArr = JSON.parse(val);
        if (this.gateId === '0') this.$emit("change", this.gateArr[0]);
        this.$forceUpdate();
      },
      deep:true
    },
  },
  computed: {
  },
  mounted() {
    if (this.gateArrStr && this.gateArrStr.length > 0) this.gateArr = JSON.parse(this.gateArrStr);
    // console.log(this.gateArr)
    // console.log("属性", this);
  },
  methods: {
    setValue() {
      let data = this.gateArr.filter((item) => {
        return item.Id=== Number(this.gateId);
      });
      // this.$emit("input", value);
      this.$emit("change", data[0]);
    },
  },
};
</script>

<style lang="scss">
  .gate-item {
    position: absolute;
    top: 0;
    left: 20px;
    width:100%;
    .el-tabs__item{
      height: 35px;
      font-size: 16px;
    }
    .el-tabs__nav-wrap::after{
      background-color: transparent;
    }
    .el-badge__content.is-fixed{
      top: 8px;
    }
  }
</style>
